// extracted by mini-css-extract-plugin
export default {"dialog":"DkufXCbT0kHPa3rH"};